import { FC } from "react";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";

import CourseStatusIcon from "../CourseStatusIcon";
import type { CourseCertificate } from "../../api/compliance";

import Actions from "./Actions";
import CertificateStatus from "./CertificateStatus";
import ValidityPeriod from "./ValidityPeriod";

interface GroupProps {
  courseCertificate: CourseCertificate;
}

const Group: FC<GroupProps> = ({ courseCertificate }) => {
  const certificate = courseCertificate.actions?.downloadableCertificate || courseCertificate.certificate;
  if (!certificate) {
    return null;
  }

  return (
    <>
      <TableRow>
        <TableCell style={{ width: "2%" }}>
          <CourseStatusIcon status={certificate?.status} />
        </TableCell>
        <TableCell>
          <Typography variant="body2">
            ({courseCertificate.id}) {courseCertificate.name}
          </Typography>
          <Typography variant="subtitle2" color="textSecondary">
            (g_{courseCertificate.group?.id}) {courseCertificate.group?.name}
          </Typography>
        </TableCell>
        <TableCell style={{ width: "10%" }}>
          <ValidityPeriod courseCertificate={courseCertificate} />
        </TableCell>
        <TableCell style={{ width: "15%" }}>
          <CertificateStatus validUntil={certificate.validUntil} status={certificate.status} />
        </TableCell>
        <TableCell style={{ width: "12%" }} align={"justify"}>
          <Actions courseCertificate={courseCertificate} />
        </TableCell>
      </TableRow>
    </>
  );
};

export default Group;
